import Vue from "vue";

Vue.filter("decimal", (value, length = 2) => {
  let num = Number(value);
  if (Number.isInteger(value)) {
    return num;
  } else {
    return num.toFixed(length);
  }
});
